import React from 'react';

import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import UserHomePage from '../UserHomePage';
import WelcomeTourHomePage from '../WelcomeTourHomePage';
import AdminHomePage from 'features/admin/home/HomePage';
import { isWelcomeTourRunningSelector } from 'redux/selectors/onboardingSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

export default function HomePage() {
  const isAdmin = useAppSelector(isAdminSelector);
  const isWelcomeTourRunning = useAppSelector(isWelcomeTourRunningSelector);

  const renderHomePage = () => {
    if (isAdmin) {
      return <AdminHomePage />;
    }

    return isWelcomeTourRunning ? <WelcomeTourHomePage /> : <UserHomePage />;
  };

  return <>{renderHomePage()}</>;
}
